import React from 'react';
import Abnormal from '@/pages/dashboard/components/Abnormal';
import { useIntl } from 'umi';
import './index.scss';

const MetricCardCo = (props: any) => {

  const { children, config, ...restProps } = props;
  const { usertag, retention, [config?.apiDataKey]: apiData } = props?.data || {};
  const { formatMessage } = useIntl();

  const componentItem = (
    // 保证是jsx数组，而不是其他类型数组
    React.Children.map(children, (child: any) => {
      return React.cloneElement(
        child,
        {
          ...restProps,
          state: {}
        }
      );
    })
  );

  return (
    <Abnormal
      isLoading={usertag?.loading || retention?.loading || (config?.apiDataKey ? apiData?.loading : false)}
      isError={usertag?.errorMsg || retention?.errorMsg || (config?.apiDataKey ? apiData?.errorMsg : false)}
      style={{ background: '#fff', marginTop: '20px', height: '165px', ...(restProps?.style || {}) }}
      component={componentItem}
      failedMsg={formatMessage({ id: 'common_loading_failed_realtime'})}
    />
  );
};

export default MetricCardCo;
